import React, { useState } from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";

import { ExpandMore, InfoRounded } from "@mui/icons-material";

interface AllergenItem {
  title: string;
  ingredients: string[];
  description: string;
}

interface ExpandableAllergenProps {
  expanded?: boolean;
  allergen: AllergenItem;
}

export const ExpandableAllergen = ({
  allergen,
  expanded = false,
}: ExpandableAllergenProps) => {
  const theme = useTheme();
  const [isExpanded, setIsExpanded] = useState(expanded);
  return (
    <Accordion
      expanded={isExpanded}
      onChange={(_, value) => setIsExpanded?.(value)}
      sx={{
        borderWidth: 0,
        width: "100%",
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMore />}
        sx={{
          backgroundColor: isExpanded
            ? theme.palette.allergy.soft
            : theme.palette.extras.warningXXLight,
        }}
      >
        <Stack direction="row" gap={1.5}>
          <InfoRounded
            fontSize="small"
            sx={{
              "&&": { color: `${theme.palette.allergy.hard} !important` },
            }}
          />
          <Typography variant="body2" textAlign="left">
            {allergen.title}
          </Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails
        sx={({ spacing }) => ({
          backgroundColor: theme.palette.allergy.soft,
          padding: `0 ${spacing(6)} ${spacing(2)}`,
        })}
      >
        <Stack gap={1} alignItems="flex-start">
          <Typography variant="body2" sx={{ fontSize: 12 }}>
            {allergen.ingredients.join(", ")}
          </Typography>
          <Typography variant="body2" textAlign="left">
            {allergen.description}
          </Typography>
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
};
